import { useQuery } from 'react-query';
import { queryAllNAF } from './useNafList.query';
import { UseNafListOptions } from './useNafList.types';
import { AllNafResponse } from '../../../types/api/endpoints/consultations/allNAF.types';

export const ALL_NAF_QUERY_KEY = 'ALL_NAF';

export const useNafList = (options?: UseNafListOptions) => {
  return useQuery<AllNafResponse, Error>(ALL_NAF_QUERY_KEY, () => queryAllNAF(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
